module.exports = __webpack_public_path__ + "img/1c_FAD.8a3ec638.jpg";